import React from 'react';
import { ScarcityBanner } from '../components/ScarcityBanner';
import { HeroLP4 } from '../components/HeroLP4';
import { Testimonial } from '../components/Testimonial';
import { WebsiteDemoLP4 } from '../components/WebsiteDemoLP4';
import { ProblemSolutionLP4 } from '../components/ProblemSolutionLP4';
import { ValueStackLP4 } from '../components/ValueStackLP4';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { ClosingLP4 } from '../components/ClosingLP4';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP4() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1338">
      <ScarcityBanner data-id="element-1339" />
      <HeroLP4 data-id="element-1340" />
      <Testimonial data-id="element-1341" />
      <WebsiteDemoLP4 data-id="element-1342" />
      <ProblemSolutionLP4 data-id="element-1343" />
      <ValueStackLP4 data-id="element-1344" />
      <ModuleBreakdown data-id="element-1345" />
      <Guarantee data-id="element-1346" />
      <ClosingLP4 data-id="element-1347" />
      <Footer data-id="element-1348" />
      <RecentPurchaseToast data-id="element-1349" />
    </div>;
}